import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 重要性判定(IFRS基準)のENUM */
enum ImportJudgeIfrsCriteria {
  /** 実施しない */
  notExecute = '0',
  /** 実施する */
  execute = '1',
}

const nameConfig = {
  notExecute: new Map([[Locale.ja, '実施しない']]),
  execute: new Map([[Locale.ja, '実施する']]),
};

const toEnum = rawValueToEnum(ImportJudgeIfrsCriteria, ImportJudgeIfrsCriteria.notExecute);
const toDisplay = enumToName(ImportJudgeIfrsCriteria, nameConfig);
const toDisplayWithPrefix = enumToName(ImportJudgeIfrsCriteria, nameConfig, { prefix: true });

export const importJudgeIfrsCriteria = {
  enum: ImportJudgeIfrsCriteria,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ImportJudgeIfrsCriteria };
